var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSheets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.545 0c.557 0 1.092.203 1.491.565l4.314 3.912c.416.376.65.894.65 1.435V22c0 1.105-.958 2-2.14 2H3.14C1.959 24 1 23.105 1 22V2c0-1.105.958-2 2.14-2h13.405zM2.835 2c0-.158.137-.286.306-.286h12.526v4.572h5.498V22c0 .158-.137.286-.306.286H3.141c-.17 0-.306-.128-.306-.286V2z",
    fill: "#515864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.889 10.8v8.4H18.11v-8.4H5.89zm5.355 7.03H7.395v-2.148h3.849v2.147zm0-3.512H7.395V12.17h3.849v2.147zm5.36 3.511h-3.848v-2.147h3.849v2.147zm0-3.511h-3.848V12.17h3.849v2.147z",
    fill: "#515864"
  })));
}
export default SvgGoogleSheets;